import { render, staticRenderFns } from "./RoomMessageForm.vue?vue&type=template&id=1ee90dfa&"
import script from "./RoomMessageForm.vue?vue&type=script&lang=js&"
export * from "./RoomMessageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports